import {
  Component,
  inject,
  signal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { TranslationService } from '@core/services/translation.service';
import { DvDialogContent, DvRadioGroupComponent } from '@devinco/ui/dds';
import { DvEditorsModule } from '@devinco/ui/legacy';
import { environment } from '@env/environment';
import { TranslateService } from '@ngx-translate/core';
import { TranslationLanguage } from '@shared/constants/translation-lang';
import { take } from 'rxjs';

@Component({
  imports: [DvRadioGroupComponent, DvEditorsModule],
  selector: 'app-language-dialog',
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './language-dialog.component.html',
})
export class LanguageDialogComponent extends DvDialogContent<
  undefined,
  LanguageDialogComponent
> {
  private readonly translate = inject(TranslateService);
  private readonly translation = inject(TranslationService);

  value = signal(TranslationLanguage.NO);
  items: { value: TranslationLanguage; label: string }[] = [];
  radioGroupItemsDirection: 'horizontal' | 'vertical' = 'horizontal';

  constructor() {
    super();
    const translate = this.translate;

    this.items = [
      {
        value: TranslationLanguage.EN,
        label: translate.instant('Language.English'),
      },
      {
        value: TranslationLanguage.NO,
        label: translate.instant('Language.Norwegian'),
      },
      {
        value: TranslationLanguage.SV,
        label: translate.instant('Language.Swedish'),
      },
    ];
    this.value.set(this.translate.currentLang as TranslationLanguage);

    if (!environment.production) {
      this.items.push({
        value: TranslationLanguage.Development,
        label: translate.instant('Language.Development'),
      });
      this.radioGroupItemsDirection = 'vertical';
    }
  }

  onValueChange(event: unknown): void {
    this.value.set(event as TranslationLanguage);
  }

  performSave(): void {
    this.translation.setTranslation(this.value()).pipe(take(1)).subscribe();
  }
}
